import { useAuth } from "context/AuthContext";
import { useState } from "react";
import styled from "styled-components";
import { ReportModal } from "ui/base/class/components/ReportModal";
import { ReviewModal } from "ui/base/class/components/ReviewModal";
import { PastClassCard } from "ui/base/class/PastClassCard";
import { UserProfileModal } from "ui/base/class/UserProfileModal";
import { hideScrollBar } from "ui/base/scrollbarStyle/scrollbarStyle";
import { LoginModal } from "ui/blocks/AuthModals/loginModal/LoginModal";
import { SignupModal } from "ui/blocks/AuthModals/singupModal/SignupModal";
import { fonts } from "../../../../ui/theme";

import NoClassRequestFound from "ui/icons/not-found-icons/noPastClasses.svg";
import { NoContent } from "ui/base/NoContent/NoContent";

export const PastClasses = ({ pastClasses, onSendMessage }) => {
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [isReportModalVisible, setShowReportModal] = useState(false);

  const [showLogin, setShowLoginModal] = useState(false);
  const [showSignUp, setShowSignUpModal] = useState(false);

  const [selectedClass, setSelectedClass] = useState(null);

  const { token } = useAuth();

  const showReportModal = () => {
    if (!token) {
      setShowLoginModal(true);
      return;
    }
    setShowReportModal(true);
  };

  return (
    <>
      {selectedClass ? (
        <ReviewModal
          show={showReviewModal}
          handleClose={() => {
            setSelectedClass(null);
            setShowReviewModal(false);
          }}
          selectedClass={selectedClass}
          isInstructor
        />
      ) : null}

      {selectedClass && isReportModalVisible ? (
        <ReportModal
          isVisible={isReportModalVisible}
          onClose={() => {
            setSelectedClass(null);
            setShowReportModal(false);
          }}
          classDetail={selectedClass}
        />
      ) : null}

      {showSignUp ? (
        <SignupModal
          show={showSignUp}
          handleClose={() => setShowSignUpModal(false)}
          setLoginModal={setShowLoginModal}
        />
      ) : null}

      {showLogin ? (
        <LoginModal
          show={showLogin}
          handleClose={() => setShowLoginModal(false)}
          setSignupModal={setShowSignUpModal}
          hasHelperText={false}
        />
      ) : null}

      {selectedClass && showProfileModal ? (
        <UserProfileModal
          show={showProfileModal}
          handleClose={() => {
            setSelectedClass(null);
            setShowProfileModal(false);
          }}
          handleSendMessage={() => {
            onSendMessage(selectedClass?.user_id)
            setShowProfileModal(false);
            setSelectedClass(null);
          }}
          userId={selectedClass.user_id}
          isInstructor
        />
      ) : null}

      <Content>
        <Title>Past Classes</Title>
        {pastClasses?.length ? (
          <ClassList>
            {pastClasses?.map((pastClass) => (
              <PastClassCard
                pastClass={pastClass}
                key={pastClass.id}
                onReview={() => {
                  setSelectedClass(pastClass);
                  setShowReviewModal(true);
                }}
                onReport={() => {
                  setSelectedClass(pastClass);

                  showReportModal();
                }}
                onProfile={() => {
                  setSelectedClass(pastClass);
                  setShowProfileModal(true);
                }}
              />
            ))}
          </ClassList>
        ) : (
          <NoContent
            title="No past class found"
            image={NoClassRequestFound}
            size={280}
          />
        )}
      </Content>
    </>
  );
};

const Content = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  overflow-y: scroll;
  gap: 1.5rem;
  height: 100%;
  /* padding-bottom: 1.5rem; */
  ${hideScrollBar}
`;

const ClassList = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 0.8rem;

  & > div {
    height: fit-content;
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const Title = styled.p`
  font-size: ${fonts.sizes.medium};
  font-weight: 600;
  text-align: left;
  text-transform: capitalize;

  @media (max-width: 1024px) {
    display: none;
  }
`;
